<ng-container *transloco="let t">
  @if (page$ | async; as page) {
    <bgo-category-landing-page-banner
      class="mt-xl h-layout"
      [content]="page.content"
      (callToActionClicked)="handleMainActionClick(page)"
    ></bgo-category-landing-page-banner>
    <bgo-category-landing-page-content
      #contentSection
      [content]="page.content.sections"
      (howItWorksCtaClicked)="handleMainActionClick(page)"
      (reviewCtaClicked)="handleMainActionClick(page)"
      (videoSectionCtaClicked)="handleMainActionClick(page)"
      class="mt-2xl"
    ></bgo-category-landing-page-content>
    <bgo-sticky-bottom-navigation
      [class.sticky-navigation-show]="showStickyFooter"
      [offeringId]="getOfferingId(page)"
      [mainCta]="page.content.primaryCallToAction"
    ></bgo-sticky-bottom-navigation>
  }
</ng-container>
